module.exports = "<aside class=\"aside-menu\">\r\n\r\n</aside>\r\n"